import componentRegistry from '../registry.js';
import './seller-header.less';

const CLASSNAMES = {
  MORE_DESC_BUTTON: '.js-moreSellerDescButton',
  MORE_DESC_END: '.js-moreSellerDescEnd',
  MORE_DESC_ELLIPSIS: '.js-moreSellerDescEllipsis',
  BUTTON_BACK: '.js-historyBack',
};

export default class SellerHeader {
  #moreDescButton;
  #moreDescEnd;
  #moreDescEllipsis;
  #buttonBack;

  constructor({ el }) {
    this.el = el;
    this.#moreDescButton = document.querySelector(CLASSNAMES.MORE_DESC_BUTTON);
    this.#moreDescEnd = document.querySelector(CLASSNAMES.MORE_DESC_END);
    this.#moreDescEllipsis = document.querySelector(CLASSNAMES.MORE_DESC_ELLIPSIS);
    this.#moreDescButton?.addEventListener('click', (e) => this._MoreDescClick());
    this.#buttonBack = document.querySelector(CLASSNAMES.BUTTON_BACK);
    this.#buttonBack?.addEventListener('click', (e) => this._BackHistory());
  }

  _MoreDescClick() {
    this.#moreDescEnd.classList.toggle('isActive');
    this.#moreDescEllipsis.classList.toggle('isActive');

    if (this.#moreDescEnd.classList.contains('isActive')) {
      this.#moreDescButton.innerHTML = this.#moreDescButton.dataset.hide;
      this.#moreDescButton.ariaExpanded = 'true';
    } else {
      this.#moreDescButton.innerHTML = this.#moreDescButton.dataset.show;
      this.#moreDescButton.ariaExpanded = 'false';
    }
  }

  _BackHistory() {
    var urlBack = this.#buttonBack.dataset.home;

    if (document.referrer.includes(urlBack)) {
      history.back();
    } else {
      window.location.href = urlBack;
    }
  }
}

componentRegistry.define('js-SellerHeader', SellerHeader);
